export default __webpack_public_path__ + "static/N0169-69980ab6f8aadcbfefeb023cdab917b2.png";